import { render } from "./ExpiryReport.vue?vue&type=template&id=0d40088a&scoped=true"
import script from "./ExpiryReport.vue?vue&type=script&lang=js"
export * from "./ExpiryReport.vue?vue&type=script&lang=js"

import "./ExpiryReport.vue?vue&type=style&index=0&id=0d40088a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d40088a"]])

export default __exports__